import { render, staticRenderFns } from "./clazz.vue?vue&type=template&id=1fb98d40&scoped=true&"
import script from "./clazz.vue?vue&type=script&lang=js&"
export * from "./clazz.vue?vue&type=script&lang=js&"
import style0 from "./clazz.vue?vue&type=style&index=0&id=1fb98d40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb98d40",
  null
  
)

export default component.exports